import { render } from "./categoryIndex.vue?vue&type=template&id=dc282764"
import script from "./categoryIndex.vue?vue&type=script&lang=js"
export * from "./categoryIndex.vue?vue&type=script&lang=js"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__